import Resource from './resource-class'

class ExperimentClassAPI extends Resource {
  constructor () {
    super()
    this.resource = '/experiment_class'
  }
}

export default new ExperimentClassAPI()
